import React from "react";
import { Card, Typography, Grid, Avatar } from "@mui/material";

interface DynamicCardContentProps {
	title?: string;
	data?: { label: string; value: string }[];
	className?: string;
	imageUrl?: string;
	startSize?: number;
	endSize?: number;
}

const DynamicCardContent: React.FC<DynamicCardContentProps> = ({
	title,
	className,
	data,
	imageUrl,
	startSize = 6,
	endSize = 6,
}) => {
	return (
		<Card className={`p-3 ${className}`} sx={{ mb: 2 }}>
			{title && (
				<Typography variant="h6" mb={2} className="!text-lg !font-semibold">
					{title}
				</Typography>
			)}

			{imageUrl && (
				<Avatar
					src={imageUrl}
					variant="square"
					sx={{ width: "100%", height: 200, mb: 2, borderRadius: "10px" }}
				/>
			)}

			<Grid container spacing={2}>
				{(data || []).map((item, index) => (
					<Grid container item xs={12} key={index} spacing={2}>
						<Grid item xs={startSize}>
							<Typography
								variant="body2"
								className="!text-base !font-normal text-gray-500"
							>
								{item.label || "-"}
							</Typography>
						</Grid>
						<Grid item xs={endSize}>
							<Typography variant="body2" className="!text-base !font-medium">
								{item.value || "-"}
							</Typography>
						</Grid>
					</Grid>
				))}
			</Grid>
		</Card>
	);
};

export default DynamicCardContent;
